import { client } from '../client';
import { UserProfile } from './types/UserProfile';

/** DELETE /collector/users/:id — deactivate/remove user in collector scope. */
export const deleteCollectorUserById = async (userId: number): Promise<UserProfile> => {
  const { data } = await client.delete<UserProfile>(`/collector/users/${userId}`);
  return data;
};
